import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  ICreateWorkspacePayload,
  IRenameWorkspacePayload,
  IDeleteWorkspacesPayload,
} from './types'

const config: AxiosRequestConfig = {
  responseType: 'json'
}

export function createWorkspace(payload: ICreateWorkspacePayload) {
  return axios.post(`/api/v1/accounts/${payload.accountId}/create_workspace`, convertToSnakeCase(payload), config)
}

export function renameWorkspace(payload: IRenameWorkspacePayload) {
  return axios.put(`/api/v1/workspaces/${payload.workspaceId}/rename`, convertToSnakeCase(payload), config)
}

export function deleteWorkspaces(payload: IDeleteWorkspacesPayload) {
  return axios.delete(`/api/v1/workspaces/`,  { ...config, data: convertToSnakeCase(payload) })
}
